import { z } from 'zod';

// Most edges have no props, but some do
export const EmptyEdgePropsSchema = z.object({});

// Edge with notes/metadata
export const AnnotatedEdgePropsSchema = z.object({
  notes: z.string().optional(),
  created_by: z.string().optional(), // User ID
  metadata: z.record(z.any()).optional(),
});

// WORKS_AT edge
export const WorksAtEdgePropsSchema = z.object({
  title: z.string().optional(),
  role: z.string().optional(),
  start_date: z.string().datetime().optional(),
  end_date: z.string().datetime().optional(),
  is_primary: z.boolean().optional(),
});

// AFFILIATED_WITH edge (non-employee relationships: board, advisor, consultant, etc.)
// Role is validated against tenant picklist 'affiliation_role' at runtime
export const AffiliatedWithEdgePropsSchema = z.object({
  role: z.string(),
  title: z.string().optional(),
  start_date: z.string().datetime().optional(),
  end_date: z.string().datetime().optional(),
  notes: z.string().optional(),
});

// APPLIES_TO edge (for CapitalCall/Distribution → Investor)
export const AppliesToEdgePropsSchema = z.object({
  investor_amount: z.number().positive('Amount must be positive'),
  payment_status: z.string().default('pending'),
  paid_date: z.string().datetime().optional(),
  notes: z.string().optional(),
});

// INVESTED_IN edge (Investment → Organization)
export const InvestedInEdgePropsSchema = z.object({
  investment_date: z.string().datetime(),
  amount: z.number().positive(),
  currency: z.string().length(3).default('USD'),
  ownership_percentage: z.number().min(0).max(100).optional(),
  valuation: z.number().positive().optional(),
  round_type: z.string().optional(), // e.g., "Series A"
});

// CONTACT_FOR edge (Person → Opportunity)
export const ContactForEdgePropsSchema = z.object({
  role: z.string().min(1, 'Role is required'),
  notes: z.string().optional(),
});

export type EmptyEdgeProps = z.infer<typeof EmptyEdgePropsSchema>;
export type AnnotatedEdgeProps = z.infer<typeof AnnotatedEdgePropsSchema>;
export type WorksAtEdgeProps = z.infer<typeof WorksAtEdgePropsSchema>;
export type AffiliatedWithEdgeProps = z.infer<typeof AffiliatedWithEdgePropsSchema>;
export type AppliesToEdgeProps = z.infer<typeof AppliesToEdgePropsSchema>;
export type InvestedInEdgeProps = z.infer<typeof InvestedInEdgePropsSchema>;
export type ContactForEdgeProps = z.infer<typeof ContactForEdgePropsSchema>;
